import script from "./LabelDPD.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelDPD.vue?vue&type=script&setup=true&lang=ts"

import "./LabelDPD.vue?vue&type=style&index=0&id=5f0b6dd5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f0b6dd5"]])

export default __exports__